import styled from 'styled-components'

export const Title = styled.h2`
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  font-size: 22px;
  line-height: 140%;
  text-align: center;
  color: ${(p) => p.theme.colors.defaultLightActive};
`
